import { toolkitSearchSchema } from "@/components/toolkit/use-toolkit-profile";
import { ensureOrgContext } from "@/lib/utils/org-context-guard";
import { getOrganizationType } from "@/lib/utils/organization";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { OrgRouteContext } from "./route";

export const Route = createFileRoute("/(org)/o/$orgSlug/earnings")({
  beforeLoad: ({ context, params }) => {
    const { organization } = context as OrgRouteContext;
    if (
      !ensureOrgContext(
        organization,
        "(org)/o.$orgSlug/earnings.tsx#beforeLoad",
        { orgSlug: params.orgSlug },
      )
    ) {
      throw redirect({ to: "/", search: { error: "organization_not_found" } });
    }
    // Earnings are per creator; agencies don't get the page (EPD-8894 PQ3).
    if (getOrganizationType(organization.metadata) === "agency") {
      throw redirect({
        to: "/o/$orgSlug/dashboard",
        params: { orgSlug: params.orgSlug },
      });
    }
  },
  // `?profile=<slug>` picks the profile when the org has more than one.
  validateSearch: toolkitSearchSchema,
});
